import { randomize } from './randomize'

export const members = [
  { name: 'ひかる', part: 'Vocal' },
  { name: 'まこと', part: 'Vocal' },
  { name: '純音', part: 'Songs & Lyrics' },
  { name: 'みりん', part: 'Illusts' },
  { name: 'Yumuta', part: 'Mixing & Mastering' },
  { name: 'ぱやし', part: 'Movies' },
  { name: 'すだ', part: 'PR' },
]

export const message = randomize(
  '私には、見たい景色がある。',
  'いつもより少しだけ、空が晴れやかに見えた。',
  'きらきら、もやもや、どきどき、ふわふわ。私の毎日は、いろんな色をしている。',
  '階段を降りると、ハムエッグのいい匂い。',
  '今日の夕焼けは、最近で一番きれいだ。'
)
